import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DxDropDownBoxComponent, DxTreeViewComponent } from 'devextreme-angular';
import { Subscription } from 'rxjs';
import { TypeActionCorrectiveRapportIncident } from 'src/api/models';
import { DevExtremeTranslationService } from 'src/core/services/devExtremeTranslation.service';
import { PanelLayoutService } from 'src/core/services/panel-layout.service';

@Component({
  selector: 'app-action-corrective-select',
  templateUrl: './action-corrective-select.component.html',
  styleUrls: ['./action-corrective-select.component.css']
})
export class ActionCorrectiveSelectComponent implements OnInit {
  @ViewChild('dxDropDown') dropDown: DxDropDownBoxComponent;
  @ViewChild('actionsTree') actionsTree: DxTreeViewComponent;

  @Input() width: number;
  @Input() widthPopUp: number = 250;

  @Input() ActionIds: TypeActionCorrectiveRapportIncident[];
  @Input() titleNull: string;
  @Output() ActionIdsChange = new EventEmitter<TypeActionCorrectiveRapportIncident[]>();

  @Input() cell: any;

  @Input() disabled: boolean = false;

  InitId = null;

  placeholder: string;

  Actions: any[] = [];
  ColumnName = [];

  p: Subscription;

  selectionMode: string;

  constructor(private panelLayoutService: PanelLayoutService,
    private translateService: TranslateService,
    private devExtremeTranslationService: DevExtremeTranslationService) {
    // Instanciate Globalize for DevExtreme components
    this.devExtremeTranslationService.loadLanguage(this.translateService.getBrowserLang());
  }

  ngOnInit() {
    this.Actions.push({id: 0, name: this.translateService.instant('Rapports.RapportsIncidents.ActionCorrectives.Archivage')});
    this.Actions.push({id: 1, name: this.translateService.instant('Rapports.RapportsIncidents.ActionCorrectives.AppelTel')});
    this.Actions.push({id: 2, name: this.translateService.instant('Rapports.RapportsIncidents.ActionCorrectives.CourrierSensibilisation')});
    this.Actions.push({id: 3, name: this.translateService.instant('Rapports.RapportsIncidents.ActionCorrectives.CourrierAvertissement')});
    this.Actions.push({id: 4, name: this.translateService.instant('Rapports.RapportsIncidents.ActionCorrectives.CourrierExclusionTemporaire')});
    this.Actions.push({id: 5, name: this.translateService.instant('Rapports.RapportsIncidents.ActionCorrectives.CourrierExclusionDefinitive')});
    this.Actions.push({id: 6, name: this.translateService.instant('Rapports.RapportsIncidents.ActionCorrectives.VisionnageCamera')});
    this.Actions.push({id: 7, name: this.translateService.instant('Rapports.RapportsIncidents.ActionCorrectives.DepotPlainte')});
    this.Actions.push({id: 8, name: this.translateService.instant('Rapports.RapportsIncidents.ActionCorrectives.Assurance')});
    this.Actions.push({id: 9, name: this.translateService.instant('Rapports.RapportsIncidents.ActionCorrectives.Reparation')});
    this.Actions.push({id: 10, name: this.translateService.instant('Rapports.RapportsIncidents.ActionCorrectives.Communication')});
    this.Actions.push({id: 11, name: this.translateService.instant('Rapports.RapportsIncidents.ActionCorrectives.Autres')});

    this.placeholder = this.translateService.instant("SelectActionCorrective");

    if (this.ActionIds) {
      this.updateSelection(this.actionsTree?.instance);
    }
  }

  onActionSelectionChanged(e) {
    this.ActionIds = [... e.component.getSelectedNodeKeys()];
    if (this.InitId != this.ActionIds && !!this.cell) {
      this.cell.setValue(this.ActionIds);
    }
    this.ActionIdsChange.emit(this.ActionIds);
  }

  onContentReady(e) {
    this.updateSelection(e.component);
  }

  updateSelection(action) {
    let actionIds = [...this.ActionIds];
    if (!action) return;

    if(this.ActionIds) {
      action.unselectAll();
      actionIds.forEach((value) => {
        let actionToSelect = this.Actions.find(p => p.id == value);
        if (actionToSelect) {
          action.selectItem(actionToSelect);
        }
      });
    }
  }

  onOpened() {
    document.body.childNodes.forEach(element => {
      if(element.nodeType == 1) {
        if((element as HTMLElement).className.includes("dx-dropdowneditor-overlay")) {
          (element.childNodes[0] as HTMLElement).style.width = `${this.widthPopUp}px`;
        }
      }
    });
  }
}


